var map = {
	"./banner_shopee.svg": 87,
	"./g_Vector.svg": 88,
	"./havecard-1.svg": 89,
	"./havecard-2.svg": 90,
	"./havecard-3.svg": 91,
	"./havecard-4.svg": 92,
	"./icon-facebook.svg": 20,
	"./icon-instagram.svg": 21,
	"./icon-linkedin.svg": 22,
	"./jakarta-gray.svg": 93,
	"./jakarta.svg": 94,
	"./kualaLumpur-gray.svg": 95,
	"./kualaLumpur.svg": 96,
	"./left_empty_triangle.svg": 23,
	"./left_triangle.svg": 97,
	"./manila-gray.svg": 98,
	"./manila.svg": 99,
	"./shenzhen-gray.svg": 100,
	"./shenzhen.svg": 101,
	"./shopee_white.svg": 102,
	"./singapore-gray.svg": 103,
	"./singapore.svg": 104,
	"./taiwan-gray.svg": 105,
	"./taiwan.svg": 106,
	"./teams-dev-commer.svg": 107,
	"./teams-intelligence.svg": 108,
	"./teams-marketing.svg": 109,
	"./teams-operations.svg": 110,
	"./thailand-gray.svg": 111,
	"./thailand.svg": 112,
	"./them_arrow.svg": 24,
	"./triangle_1.png": 113,
	"./two_red_triangle.svg": 114,
	"./two_session_triangle.svg": 25,
	"./two_triangle_xie.svg": 115,
	"./vietnam-gray.svg": 116,
	"./vietnam.svg": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;